import AboutUsComponents from "../components/AboutUsComponents";
import PageTitleSection from "../components/ReusableComponents/PageTitleSection";

function AboutUs() {
  return (
    <>
      <PageTitleSection title={'ჩვენ შესახებ'}/>
      <AboutUsComponents />
    </>
  );
}

export default AboutUs;
